import { Column } from '../../components/Table/Column';

export default (condition: boolean, ...elements: Column[]) => (condition ? elements : []);
